import React from 'react';
import classNames from 'classnames/bind';
import styles from './index.pcss';

const cx = classNames.bind(styles);

const ProductLoaderCard = ({ ajiogram }: { ajiogram: boolean }) => {
  const ajiogramShimmerStyle = { ajiogram };

  return (
    <div className={cx('product-loader-card', ajiogramShimmerStyle)}>
      <div className={cx('shimmer', 'product-loader-image', ajiogramShimmerStyle)} />
      <div className={cx('product-loader-content')}>
        <div className={cx('shimmer', 'product-loader-title', ajiogramShimmerStyle)} />
        <div className={cx('shimmer', 'product-loader-description', ajiogramShimmerStyle)} />
        <div className={cx('shimmer', 'product-loader-description', 'short', ajiogramShimmerStyle)} />
      </div>
    </div>
  );
};

const ProductLoader = ({ ajiogram }: { ajiogram: boolean }) => {
  return (
    <div className={cx('product-loader-grid')}>
      <ProductLoaderCard ajiogram={ajiogram} />
      <ProductLoaderCard ajiogram={ajiogram} />
      <ProductLoaderCard ajiogram={ajiogram} />
      <ProductLoaderCard ajiogram={ajiogram} />
    </div>
  );
};

export default ProductLoader;
